import { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import FAQ from "./pages/FAQ";
import About from "./pages/About";
import TurnaroundTime from "./pages/TurnaroundTime";
import Checkout from "./pages/Checkout";
import Confirmation from "./pages/Confirmation";
import DesignDetailsForm from "./pages/DesignDetailsForm";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import AuthCallback from "./pages/AuthCallback";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider } from "./components/AuthProvider";

// Detect Emergent Auth callback (session_id in URL fragment) before normal routing.
const AppRouter = ({ cartItems, onAddToCart, onRemoveFromCart, onUpdateQuantity, onClearCart }) => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home cartItems={cartItems} onAddToCart={onAddToCart} onRemoveFromCart={onRemoveFromCart} onUpdateQuantity={onUpdateQuantity} />} />
      <Route path="/faq" element={<FAQ cartItems={cartItems} onRemoveFromCart={onRemoveFromCart} onUpdateQuantity={onUpdateQuantity} />} />
      <Route path="/about" element={<About cartItems={cartItems} onRemoveFromCart={onRemoveFromCart} onUpdateQuantity={onUpdateQuantity} />} />
      <Route path="/turnaround-time" element={<TurnaroundTime cartItems={cartItems} onRemoveFromCart={onRemoveFromCart} onUpdateQuantity={onUpdateQuantity} />} />
      <Route path="/checkout" element={<Checkout cartItems={cartItems} onRemoveFromCart={onRemoveFromCart} onUpdateQuantity={onUpdateQuantity} />} />
      <Route path="/confirmation" element={<Confirmation cartItems={cartItems} onRemoveFromCart={onRemoveFromCart} onUpdateQuantity={onUpdateQuantity} onClearCart={onClearCart} />} />
      <Route path="/design-details" element={<DesignDetailsForm cartItems={cartItems} onRemoveFromCart={onRemoveFromCart} onUpdateQuantity={onUpdateQuantity} />} />
      <Route path="/dashboard" element={<Dashboard cartItems={cartItems} onRemoveFromCart={onRemoveFromCart} onUpdateQuantity={onUpdateQuantity} />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
};

function App() {
  const [cartItems, setCartItems] = useState([]);

  const handleAddToCart = (bundle) => {
    const existingItem = cartItems.find(
      item => item.id === bundle.id && item.priceType === bundle.priceType
    );

    if (existingItem) {
      setCartItems(
        cartItems.map(item =>
          item.id === bundle.id && item.priceType === bundle.priceType
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      );
    } else {
      setCartItems([...cartItems, { ...bundle, quantity: 1 }]);
    }
  };

  const handleRemoveFromCart = (id, priceType) => {
    setCartItems(cartItems.filter(item => !(item.id === id && item.priceType === priceType)));
  };

  const handleUpdateQuantity = (id, priceType, quantity) => {
    if (quantity === 0) {
      handleRemoveFromCart(id, priceType);
    } else {
      setCartItems(
        cartItems.map(item =>
          item.id === id && item.priceType === priceType
            ? { ...item, quantity }
            : item
        )
      );
    }
  };

  const handleClearCart = () => setCartItems([]);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <AppRouter
            cartItems={cartItems}
            onAddToCart={handleAddToCart}
            onRemoveFromCart={handleRemoveFromCart}
            onUpdateQuantity={handleUpdateQuantity}
            onClearCart={handleClearCart}
          />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
